<template>
  <header class="header">
    <div class="container">
      <div class="logo">
        <router-link to="/">
          <img src="../assets/无国界切图/new-logo.png" alt="AI Without Borders Logo">
        </router-link>
      </div>
      <nav class="nav">
        <ul class="menu">
          <li><router-link to="/">Who We Are</router-link></li>
          <li><router-link to="/what-we-do">What We Do</router-link></li>
          <li><router-link to="/articles">Articles</router-link></li>
          <li><router-link to="/success-stories">Success Stories</router-link></li>
          <li><router-link to="/contact">Contact</router-link></li>
        </ul>
      </nav>
      
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader'
}
</script>

<style scoped>
.header {
  background-color: rgba(0,0,0,0.5);
  color: white;
  padding: 5px 0;
  position: sticky;
  top: 0;
  width: 100%;
  height: auto;
  min-height: 100px;
  z-index: 1000;
} 

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 0;
  gap:150px;
  text-align: center;
}

.logo {
  flex-shrink: 0;
  cursor:pointer;
}

.logo img {
  height: 80px;
  width: auto;

}

.nav {
  flex-grow: 1;
  display: flex;
  justify-content: center;
}

.menu {
  display: flex;
  list-style: none;
  gap:60px;
  margin: 0;
  padding: 0;
  font-family: PingFangSC, PingFang SC;
}

.menu li a {
  color: white;
  text-decoration: none;
  font-size: 20px;
  transition: color 0.3s;
  white-space: nowrap;
}

.menu li a:hover {
  color: var(--primary-color);
}

/* Active route styling */
.menu li a.router-link-active {
  color: var(--primary-color);
}

.search-container {
  position: relative;
  width: 250px;
  flex-shrink: 0;
}

.search-input {
  width: 100%;
  height: 30px;
  color: #FFFFFF;
  outline: none;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.1);
  padding: 0 40px 0 5px;
  border-radius: 2px;
  border: 1px solid;
  border-image: linear-gradient(225deg, rgba(70, 250, 184, 1), rgba(28, 201, 165, 1), rgba(80, 91, 255, 1)) 1 1;
}

.search-button {
  position: absolute;
  top: 50%;
  right: 0;
  width: 40px;
  height: 30px;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  background: linear-gradient(225deg, #46FAB8 0%, #1CC9A5 47%, #505BFF 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-icon {
  fill: white;
  width: 16px;
  height: 16px;
}

@media (max-width: 1024px) {
  .menu {
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .menu {
    display: none;
  }
  
  .search-container {
    display: none; /* Or move to a mobile menu */
  }
  
  .container {
    justify-content: center;
  }
}
</style>
